import React from "react"
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { Link, Users } from "lucide-react"

interface ImageShareButtonProps {
  hasFileBeenShared: boolean
  handleShareLink: (downloadFileName: string) => void
  downloadFileName: string
}

const ImageShareButton: React.FC<ImageShareButtonProps> = ({
  hasFileBeenShared,
  handleShareLink,
  downloadFileName,
}) => {
  const { t } = useTranslation()
  return (
    <Button
      variant="ghost"
      title={
        hasFileBeenShared
          ? t("chat.share.alreadyShared")
          : t("chat.share.shareFile")
      }
      onClick={(e) => {
        e.preventDefault()
        handleShareLink(downloadFileName)
      }}
      className="gap-1"
    >
      <div className="flex flex-row gap-x-1">
        {hasFileBeenShared && <Users className="mt-0.5 h-4" />}
        <span>{t("chat.share.share")}</span>
      </div>
      <Link className="h-4 w-4" />
    </Button>
  )
}

export default ImageShareButton
